<script setup lang="ts">
const solutions = [
  {
    title: 'Kemudahan',
    description: 'Fokus untuk selalu hadirkan kemudahan.'
  },
  {
    title: 'Peningkatan Kualitas',
    description: 'Selalu menjadi lebih baik di setiap proses.'
  },
  {
    title: 'Inovatif',
    description: 'Mendorong Hadirnya inovasi di dalam bisnis.'
  }
]
</script>
<template>
  <section class="py-10 lg:py-24">
    <UiSectionWrapper
      class="bg-transparent relative z-10"
      image-class="order-first"
      title="Nilai yang Kami Pegang"
      title-as="h2"
      hero-image="/images/home-v4/value_img.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="flex gap-2 items-start"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <div class="grow">
              <h5 class="font-semibold text-lg">
                {{ solution.title }}
              </h5>
              <p class="text-sm lg:text-lg flex-1">
                {{ solution.description }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
    <UiSectionWrapper
      class="bg-transparent relative z-10"
      image-class="max-w-none sticky top-24"
      title="Profil Perusahaan"
      title-as="h2"
      hero-image="/images/home-v4/ka_building_2.webp"
      title-variant-size="large"
    >
      <template #action>
        <div class="prose dark:prose-invert max-w-none">
          <p>
            KiriminAja (PT. SELALU SIAP SOLUSI) adalah sebuah perusahaan
            teknologi yang berdiri di Yogyakarta dan berfokus pada industri
            logistik sebagai aggregator jasa pengiriman, memberikan solusi
            pengiriman paket efektif dan efisien.
          </p>
          <p>
            KiriminAja melayani pemesanan pengiriman reguler, instant, kargo,
            bahkan paket volume besar menggunakan truk, serta melayani kebutuhan
            fulfillment dan pergudangan. Dengan berbagai fitur unggulan, kami
            memastikan setiap kebutuhan logistik bisnis bisa terpenuhi dengan
            mudah.
          </p>
          <p>
            Aplikasi KiriminAja tersedia melalui mobile apps dan dashboard
            website sehingga mudah untuk diakses di mana pun dan kapan pun.
            Sudah lebih dari 200 ribu pengguna mempercayakan pengirimannya
            kepada kami. Mari bergabung dengan KiriminAja!
          </p>
        </div>
      </template>
    </UiSectionWrapper>
  </section>
</template>
